import api from '../../../api/mdtravail/_employe'


const state = () => ({
    employes: null,
})

// getters
const getters = {
        employes: (state) => {
            return state.employes
        }
    }
    // mutations
const mutations = {

    SET_EMPLOYES(state, employes) {
        state.employes = employes;
    },

    ADD_EMPLOYE(state, employe) {
        state.employes.unshift(employe)
    }
}

// actions
const actions = {

    addEmployes({ commit }, data) {
        commit('ADD_EMPLOYE', data)
    },

    importEmploye({ commit,dispatch }, {id,data}) {
        return new Promise((resolve, reject) => {
            api.importEmploye(id, data).then(
                response => {
                    commit
                    console.log('savinggg', response)
                    resolve(response);
                    dispatch('listeEmployes', id)

                }, error => {

                    reject(error);
                }
            )
        })

    },
    listeEmployes({ commit }, societeId) {
        return new Promise((resolve, reject) => {
            api.listeEmployes(societeId).then(
                response => {
                    resolve(response)
                    commit('SET_EMPLOYES', response)

                }, error => {
                    reject(error)
                }
            )
        })
    }

}


export default {
    state,
    getters,
    actions,
    mutations
}